module.exports = __webpack_public_path__ + "static/media/Icon1.e7ec8ee1.svg";